import { ChangeContext } from '../../client/changeManager';
import { createDecorator } from '../definition/decorator';
import { ResolverRuntime } from '../definition/resolver';

export const changeHandling = createDecorator(
  'changeHandling',
  (attach) => (params, runtime) => {
    let pendingContext: ChangeContext | undefined;

    const log = (message: string) =>
      runtime.env.logger?.debug(message, {
        changeId: pendingContext?.changeId,
        originId: pendingContext?.originId,
      });

    const next: ResolverRuntime<any, any>['next'] = (state, meta) => {
      const currentPending = pendingContext;

      if (!state.loading && pendingContext) {
        log('clearing pending context');

        pendingContext = undefined;
      }

      if (currentPending || meta) {
        runtime.next(state, { changeContext: currentPending, ...meta });
      } else {
        runtime.next(state);
      }
    };

    const handle = attach(params, {
      ...runtime,
      next,
    });

    return {
      ...handle,
      refresh: (changeContext?: ChangeContext) => {
        if (changeContext) {
          if (!pendingContext) {
            pendingContext = changeContext;
            log('registering pending context');
          } else if (pendingContext.changeId < changeContext.changeId) {
            pendingContext = changeContext;
            log('replacing pending context');
          }
        }

        handle.refresh(changeContext);
      },
    };
  }
);
